const bankNames: Record<string, string> = {
	ACBL: 'ธนาคารสหกรณ์อันโยนยา',
	APB: 'ธนาคารส่งเสริมการเกษตร',
	BAAC: 'ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร',
	BAY: 'ธนาคารกรุงศรีอยุธยา',
	BBL: 'ธนาคารกรุงเทพ',
	BCELONE: 'ธนาคารบีซีอีแอล',
	BFL: 'ธนาคาร Banque-ฝรั่งเศสลาว',
	BIC: 'ธนาคารบีไอซี',
	CIMB: 'ธนาคารซีไอเอ็มบีไทย',
	CITI: 'ธนาคารซิตี้แบงก์',
	GHB: 'ธนาคารอาคารสงเคราะห์',
	GSB: 'ธนาคารออมสิน',
	HSBC: 'ธนาคารเอชเอสบีซี',
	IB: 'International Business Bank',
	IBANK: 'ธนาคารอิสลามแห่งประเทศไทย',
	ICBC: 'ธนาคารไอซีบีซี',
	JDB: 'The Joint Development Bank',
	KBANK: 'ธนาคารกสิกร',
	KKP: 'ธนาคารเกียรตินาคิน',
	KTB: 'ธนาคารกรุงไทย',
	LDB: 'The Lao Development Bank',
	LHBANK: 'ธนาคารแลนด์ แอนด์ เฮ้าส์',
	LVB: 'Lao-Viet Joint Venture Bank',
	MIZUHO: 'ธนาคารมิซูโฮ',
	MJBL: 'Maruhan Japan Bank Laos',
	PSVB: 'Phongsavanh bank',
	SCB: 'ธนาคารไทยพาณิชย์',
	SCB_ANY: 'ธนาคารไทยพาณิชย์',
	SCBT: 'ธนาคารสแตนดาร์ดชาร์เตอร์ด',
	STB: 'Secure Trust Bank',
	TCD: 'ธนาคารไทยเครดิต',
	TISCO: 'ธนาคารทิสโก้',
	TTB: 'ธนาคารทหารไทยธนชาติ',
	UOB: 'ธนาคารยูโอบี',
	VCB: 'ธนาคารเวียดคอมแบงก์',
	VTB: 'ธนาคารวีทีบี',
};

const bankImages: Record<string, string> = {
	ACBL: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/ACBL.webp',
	APB: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/APB.webp',
	BAAC: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/BAAC_webp.webp',
	BAY: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/BAY_webp.webp',
	BBL: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/BBL_webp.webp',
	BCELONE: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/BCELONE.webp',
	BFL: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/BFL.webp',
	BIC: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/BIC.webp',
	CIMB: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/CIMB_webp.webp',
	GHB: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/GHB_webp.webp',
	GSB: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/GSB_webp.webp',
	HSBC: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/HSBC.webp',
	IB: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/IB.webp',
	JDB: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/JDB.webp',
	KBANK: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/KBANK_webp.webp',
	KKP: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/KKP_webp.webp',
	KTB: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/KTB_webp.webp',
	LDB: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/LDB.webp',
	LHBANK: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/LHBANK_webp.webp',
	LVB: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/LVB.webp',
	MIZUHO: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/MIZUHO.webp',
	MJBL: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/MJBL.webp',
	PSVB: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/PSVB.webp',
	SCB: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/SCB_webp.webp',
	SCB_ANY: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/SCB_webp.webp',
	SCBT: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/SCBT.webp',
	STB: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/STB.webp',
	TCD: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/TCD.webp',
	TISCO: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/TISCO.webp',
	TTB: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/TTB_webp.webp',
	UOB: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/UOB_webp.webp',
	VCB: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/VCB.webp',
	VTB: 'https://tm-storage.sgp1.cdn.digitaloceanspaces.com/bank-icon/VTB.webp',
	TRUEWALLET: 'https://tm-storage.sgp1.digitaloceanspaces.com/bank-icon/true-wallet.webp',

};


const bankBgClass: Record<string, string> = {
	ACBL: 'bg-wallet-acbl',
	APB: 'bg-wallet-apb',
	BAAC: 'bg-wallet-baac',
	BAY: 'bg-wallet-bay',
	BBL: 'bg-wallet-bbl',
	BCELONE: 'bg-wallet-bcelone',
	BFL: 'bg-wallet-bfl',
	BIC: 'bg-wallet-bic',
	CIMB: 'bg-wallet-cimb',
	CITI: 'bg-wallet-citi',
	GHB: 'bg-wallet-ghb',
	GSB: 'bg-wallet-gsb',
	HSBC: 'bg-wallet-hsbc',
	IB: 'bg-wallet-ib',
	IBANK: 'bg-wallet-ibank',
	ICBC: 'bg-wallet-icbc',
	JDB: 'bg-wallet-jdb',
	KBANK: 'bg-wallet-kbank',
	KKP: 'bg-wallet-kkp',
	KTB: 'bg-wallet-ktb',
	LDB: 'bg-wallet-ldb',
	LHBANK: 'bg-wallet-lhbank',
	LVB: 'bg-wallet-lvb',
	MIZUHO: 'bg-wallet-mizuho',
	MJBL: 'bg-wallet-mjbl',
	PSVB: 'bg-wallet-psvb',
	SCB: 'bg-wallet-scb',
	SCB_ANY: 'bg-wallet-scb',
	SCBT: 'bg-wallet-scbt',
	STB: 'bg-wallet-stb',
	TCD: 'bg-wallet-tcd',
	TISCO: 'bg-wallet-tisco',
	TTB: 'bg-wallet-ttb',
	UOB: 'bg-wallet-uob',
	VCB: 'bg-wallet-vcb',
	VTB: 'bg-wallet-vtb',
	TRUEWALLET: 'bg-wallet-tw',
};

const bankBackgrounds: Record<string, string> = {
	ACBL: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/ACBL.webp',
	APB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/APB.webp',
	BAAC: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/BAAC.webp',
	BAY: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/BAY.webp',
	BAY2: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/BAY2.webp',
	BLL: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/BBL.webp',
	BCELONE: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/BCELONE.webp',
	BFL: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/BFL.webp',
	BIC: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/BIC.webp',
	CIMB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/CIMB.webp',
	CITI: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/CITI.webp',
	GHB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/GHB.webp',
	GSB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/GSB.webp',
	HSBC: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/HSBC.webp',
	IB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/IB.webp',
	IBANK: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/IBANK.webp',
	ICBC: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/ICBC.webp',
	JDB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/JDB.webp',
	KBANK: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/KBANK.webp',
	KKP: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/KKP.webp',
	KTB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/KTB.webp',
	LDB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/LDB.webp',
	LHBANK: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/LHBANK.webp',
	LVB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/LVB.webp',
	MIZUHO: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/MIZUHO.webp',
	MJBL: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/MJBL.webp',
	PSVB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/PSVB.webp',
	SCB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/scb.webp',
	SCB_ANY: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/scb.webp',
	SCBT: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/SCBT.webp',
	STB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/STB.webp',
	TCD: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/TCD.webp',
	TISCO: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/TISCO.webp',
	TTB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/TTB.webp',
	UOB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/UOB.webp',
	VCB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/VCB.webp',
	VTB: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/VTB.webp',
	TRUEWALLET: 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/TW.webp',
}

export const getBankName = (bank: string | unknown): string => typeof bank === 'string' ? bankNames[bank] : '';

// หา bank code จากค่าที่ API ส่งมา (รองรับทั้ง code ตรง ๆ และชื่อธนาคารภาษาไทย)
export const getBankCodeByName = (bank: string | unknown): string => {
	if (typeof bank !== 'string' || !bank) return '';
	const input = bank.trim();
	if (bankImages[input]) return input;
	let best = '';
	let bestLen = 0;
	for (const [code, thaiName] of Object.entries(bankNames)) {
		if (thaiName === input) return code;
		if ((input.includes(thaiName) || thaiName.includes(input)) && thaiName.length > bestLen) {
			best = code;
			bestLen = thaiName.length;
		}
	}
	return best;
};

export const getBankImage = (bank: string | unknown): string => typeof bank === 'string' ? bankImages[bank] : '';

export const getBankBgClass = (bank: string | unknown): string => typeof bank === 'string' ? bankBgClass[bank] : 'bg-[#040202bd]';

export const getBankBackground = (bank: string | unknown): string => typeof bank === 'string' ? bankBackgrounds[bank] : 'https://topgame.sgp1.cdn.digitaloceanspaces.com/theme/banks-background/none.webp';

export default {
	bankNames,
	bankImages,
	bankBgClass,
	getBankName,
	getBankCodeByName,
	getBankImage,
	getBankBackground,
	getBankBgClass,
};
